import { Box, Button, Typography } from '@mui/material';
import { Modal } from '../common/Modal';
import { TEXTS } from '../../core/texts';
import { useCallback } from 'react';
import { useConfirmationDialog } from '../../+state/useConfirmationDialog';

export const ConfirmationDialog = () => {
  const { open, text, closeDialog, cb } = useConfirmationDialog();

  const confirmHandler = useCallback(() => {
    cb();
    closeDialog();
  }, [cb, closeDialog]);

  return (
    <>
      {open &&
        <Modal onClose={closeDialog} withDividers={false} maxWidth={650} dialogActions={
          <Box width={1} p={2} display={'flex'} justifyContent={'space-between'}>
            <Button onClick={closeDialog} color={'error'} variant={'contained'}>
              {TEXTS.NO}
            </Button>
            <Button onClick={confirmHandler} variant={'contained'}>
              {TEXTS.YES}
            </Button>
          </Box>
        }>
          <Typography variant={'h3'}>
            {text}
          </Typography>
        </Modal>
      }
    </>
  );
};